import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

const NewsletterSignup = () => {
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission

    // Track the signup event using gtag from the window object
    if (window.gtag) {
      window.gtag("event", "newsletter_signup", {
        event_category: "engagement",
        event_label: "Newsletter Signup",
        value: 1, // You can change this based on your needs
      });
    }

    // Proceed with form submission
    const form = e.target;
    form.submit(); // Submit the form
  };

  return (
    <SignupContainer>
      {status === "success" ? (
        <ThankYouMessage>
          <h2>Thank You for Signing Up!</h2>
          <p>
            You have successfully signed up for the Habitat Buffalo newsletter.
            Keep an eye on your inbox for the latest stories, updates, and ways
            you can support our local families. We appreciate your support!
          </p>
        </ThankYouMessage>
      ) : (
        <>
          <Title>Sign-up for Our Newsletter</Title>
          <Description>
            Stay up to date with Habitat Buffalo stories and ways you can
            support our local families. Our quarterly newsletter includes
            updates on what we've been doing, upcoming events, a list of current
            programs, and volunteer opportunities. Sign up to get news and event
            information sent directly to your inbox!
          </Description>
          <Form
            onSubmit={handleSubmit}
            action="https://habitatbuffalo.us15.list-manage.com/subscribe/post?u=5d7743596ea119fff30b64404&amp;id=680c77a44a"
            method="POST"
            target="_blank"
          >
            <Input
              id="first-name"
              type="text"
              name="FNAME"
              placeholder="First Name"
              required
            />
            <Input
              id="last-name"
              type="text"
              name="LNAME"
              placeholder="Last Name"
              required
            />
            <Input
              id="email"
              type="email"
              name="EMAIL"
              placeholder="Email"
              required
            />
            <SignUpButton type="submit">Sign Up</SignUpButton>
          </Form>
        </>
      )}
    </SignupContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const SignupContainer = styled.section`
  background-color: var(--hhb-green);
  color: var(--hhb-white);
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  font-size: var(--font-size-heading);
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: var(--font-size-body);
  margin-bottom: 30px;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 10px;
  flex-wrap: wrap;
  background-color: var(--hhb-green);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Input = styled.input`
  padding: 10px;
  font-size: var(--font-size-body);
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;

  @media (max-width: 768px) {
    width: calc(100% - 22px); /* Adjusting width to account for padding */
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const SignUpButton = styled.button`
  padding: 10px 20px;
  background-color: var(--hhb-orange);
  color: var(--hhb-white);
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #e65a1b;
  }
`;

const ThankYouMessage = styled.div`
  font-size: var(--font-size-body);
  color: var(--hhb-white);
  margin-top: 30px;
  animation: ${fadeIn} 1s ease-in;

  h2 {
    font-size: var(--font-size-heading);
    margin-bottom: 20px;
  }

  p {
    font-size: var(--font-size-body);
    margin: 0 auto;
    max-width: 800px;
  }
`;

const Disclaimer = styled.p`
  margin-top: 20px;
  font-size: 0.75em;
  color: var(--hhb-white);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  a {
    color: var(--primary-color);
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }
`;

export default NewsletterSignup;
